import { useState } from "react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { Combobox } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function RegionDropdown({
  uniqueRegions,
  onRegionChange,
  setCurrentPage,
  selectedRegion,
  setSelectedRegion,
}) {
  const [query, setQuery] = useState("");

  // Filter the regions based on the query entered
  const filteredRegions =
    query === ""
      ? uniqueRegions
      : uniqueRegions.filter((region) =>
          region.toLowerCase().includes(query.toLowerCase())
        );

  return (
    <div className="relative">
      <Combobox
        as="div"
        value={selectedRegion || ""}
        onChange={(selectedValue) => {
          console.log("Region changed (inside Combobox):", selectedValue);
          setSelectedRegion(selectedValue);
          setCurrentPage(1);
          onRegionChange(selectedValue);
        }}
      >
        <Combobox.Label className="block text-base font-semibold leading-6 text-gray-900">
          Region
          <span className="ml-2 text-xs">Select one</span>
        </Combobox.Label>

        <div className="relative mt-2 mb-4">
          <Combobox.Input
            className="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            onChange={(event) => setQuery(event.target.value)} // Update query on change
            displayValue={(region) => region || "Select a region"} // Default placeholder text
            placeholder="Select a region" // Placeholder text
            readOnly={true} // Read-only input
          />
          <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
            <ChevronUpDownIcon className="h-5 w-5" aria-hidden="true" />
          </Combobox.Button>

          {filteredRegions.length > 0 && (
            <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {filteredRegions.map((region, index) => (
                <Combobox.Option
                  key={index}
                  value={region}
                  className={({ active }) =>
                    classNames(
                      "relative cursor-default select-none py-2 pl-3 pr-9",
                      active ? "bg-indigo-600 text-white" : "text-gray-900"
                    )
                  }
                >
                  {({ active, selected }) => (
                    <>
                      <span
                        className={classNames(
                          "block truncate",
                          selected && "font-semibold"
                        )}
                      >
                        {region}
                      </span>

                      {selected && (
                        <span
                          className={classNames(
                            "absolute inset-y-0 right-0 flex items-center pr-4",
                            active ? "text-white" : "text-indigo-600"
                          )}
                        >
                          <CheckIcon className="h-5 w-5" aria-hidden="true" />
                        </span>
                      )}
                    </>
                  )}
                </Combobox.Option>
              ))}
            </Combobox.Options>
          )}
        </div>
      </Combobox>
    </div>
  );
}

export default RegionDropdown;
